export default "__VITE_ASSET__DK1$7J4L__"